import { t } from 'i18next';
import { uniqueId } from 'lodash';

import { TOAST_TYPE } from './hooks/useToast';
import { LOGIN_PAGE, PRIVATE_ROUTE } from './routes/routes';

export const matchError = (error) => {
  const status = error?.response?.status || error.message;
  switch (status) {
    case 401:
      return {
        code: 401,
        message: t('unauthorized', { ns: 'errors' }),
        redirect: LOGIN_PAGE,
      };
    case 403:
      return {
        code: 403,
        message: t('forbidden', { ns: 'errors' }),
        redirect: PRIVATE_ROUTE.ERROR403,
      };
    case 404:
      return {
        code: 404,
        message: t('notFound', { ns: 'errors' }),
        redirect: PRIVATE_ROUTE.ERROR404,
      };
    case 500:
    case 'Network Error':
      return {
        code: 500,
        message: t('internalServerError', { ns: 'errors' }),
        redirect: PRIVATE_ROUTE.ERROR500,
      };
    default:
      return {
        message: t('unknown', { ns: 'errors', status: status || '' }),
      };
  }
};

/**
 * To show toast or redirect to the corresponding error page
 * @param {function} navigate - navigate function. Should come from useNavigate hook from react-router-dom
 * @param {object} error - error object. Usually comes from a try/catch block
 * @param {function} showToast - show toast function. Should come from useToast custom hook. See {@link useToast}
 *
 */
export const handleErrors = (navigate, error, showToast) => {
  const { code, message, redirect } = matchError(error);
  code === 403 || code === 404 || code === 500
    ? navigate(redirect, { replace: true })
    : showToast(TOAST_TYPE.ERROR, message);
};

export const getFileExtName = (name) => {
  if (!(name.split('.').length > 1)) return '';
  return name.split('.').pop();
};

export const mapToFileBrowser = (files, seq) => {
  if (!files) return;
  return files
    .filter((file) => !/^\.+$/.test(file.filename))
    .map((file) => ({
      id: uniqueId(`file_${seq}_`),
      name: file.filename,
      isDir: file.attrs?.dir,
      size: file.attrs?.size,
      ext: getFileExtName(file.filename),
      modDate: new Date(file.attrs?.mtime * 1000),
    }));
};
